import { Component, inject } from '@angular/core';
import { LocationsRouterStoreSelectors, LocationSubset } from '@era/stores';
import { NgbDropdownButtonItem, NgbDropdownItem, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {
  ContextMenuComponent,
  MasterComponent,
  MasterDetailComponent,
  PanelComponent,
  PanelHeaderComponent,
} from '@rocksoft/cdk';
import { environment } from '@rocksoft/environment';
import { EnvironmentFeatures } from '@rocksoft/shared';
import { RebootDevicesModalContainerComponent } from '../../sub-features/reboot-devices-modal/reboot-devices-modal.container';
import { DEVICE_LOCATION_SUBSET_CONFIGS } from '../devices-location-subset/device-location-subset.config';
import { DevicesLocationSubsetContainerComponent } from '../devices-location-subset/devices-location-subset.container';
import { DevicesSyncModalContainerComponent } from '../modals/devices-sync-modal/devices-sync-modal.container';
import { SelectLocationListDevicesContainerComponent } from '../select-location/select-location-list-devices/select-location-list-devices.container';

@Component({
  selector: 'era-location-devices',
  templateUrl: './location-devices.component.html',
  imports: [
    PanelComponent,
    PanelHeaderComponent,
    SelectLocationListDevicesContainerComponent,
    ContextMenuComponent,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    MasterDetailComponent,
    MasterComponent,
    DevicesLocationSubsetContainerComponent,
  ],
})
export class LocationDevicesComponent {
  private readonly modalService = inject(NgbModal);
  private readonly store = inject(Store);

  public readonly features: EnvironmentFeatures = environment.features;
  public readonly currentLocation = this.store.selectSignal(LocationsRouterStoreSelectors.selectLocation);
  public readonly deviceCategories = Object.entries(DEVICE_LOCATION_SUBSET_CONFIGS).map(([key, config]) => ({
    key,
    config,
  }));

  public openRebootRequest(): void {
    const modal = this.modalService.open(RebootDevicesModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = LocationSubset.All;
  }

  public openSyncModalRequest(): void {
    const modal = this.modalService.open(DevicesSyncModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = LocationSubset.All;
  }
}
